import { FC } from "react";

import { Button, ButtonProps } from "@mui/material";
import { Add } from "@mui/icons-material";

const GreyAddButton: FC<ButtonProps> = (props) => (
  <Button
    sx={{
      padding: "1rem",
      backgroundColor: "#BDBDBD",
      borderRadius: "1rem",
      margin: "0 0 0.25rem 0",
    }}
    {...props}
  >
    <Add sx={{ width: "2.5rem", height: "2.5rem", color: "white" }} />
  </Button>
);

export default GreyAddButton;
